import { LocalStorageKey } from '../../types'
import { Role } from '../../types/roles/roleTypes'
import { readLocalStorage } from './local-storage-helpers'
import { unmaskRUT } from './rut-helper'

/**
 * RUT empresa cuyos administradores ven menú completo (Facturación → emision-v1, Inventario con familias/subfamilias/líneas/atributos).
 * Override: REACT_APP_FULL_NAV_COMPANY_RUT en .env
 */
const DEFAULT_FULL_NAV_COMPANY_RUT =
  (typeof process !== 'undefined' && process.env?.REACT_APP_FULL_NAV_COMPANY_RUT?.trim()) ||
  '77554630-1'

function normalizeCompanyRut(value: string | undefined | null): string {
  if (!value) return ''
  return unmaskRUT(String(value).trim()).toUpperCase()
}

function isAdminUser(user?: Record<string, any> | null, userData?: Record<string, any> | null): boolean {
  const roleLabel = user?.userType ?? userData?.userType
  const idut = user?.iduser_type ?? userData?.iduser_type
  return roleLabel === Role.ADMIN || idut === 2
}

function resolveCompanyRutForSession(userData?: Record<string, any> | null): string {
  const fromSession = normalizeCompanyRut(readLocalStorage(LocalStorageKey.SESSION_COMPANY_RUT) as string)

  const ud = userData ?? readLocalStorage(LocalStorageKey.USER_DATA)
  const fromProfile =
    normalizeCompanyRut((ud as any)?.rut_company) ||
    normalizeCompanyRut((ud as any)?.company_rut) ||
    normalizeCompanyRut((ud as any)?.company?.rut)

  return fromSession || fromProfile
}

/**
 * Administradores de la empresa configurada reciben `navSections.Admin` (incluye emision-v1 y maestros de inventario).
 * Usa `user` (Redux) y/o `userData` (localStorage) para no fallar si uno aún no está hidratado.
 */
export function shouldUseFullAdminNav(
  user?: Record<string, any> | null,
  userData?: Record<string, any> | null
): boolean {
  const ud = userData ?? readLocalStorage(LocalStorageKey.USER_DATA)
  const merged = { ...(ud || {}), ...(user || {}) }

  if (!isAdminUser(merged, ud)) {
    return false
  }

  const stored = resolveCompanyRutForSession(ud)
  const expected = normalizeCompanyRut(DEFAULT_FULL_NAV_COMPANY_RUT)

  return !!stored && !!expected && stored === expected
}
